/**
 * BARQWEAR - Scroll Reveal Animation
 * Lightweight IntersectionObserver-based reveal for modern scroll effects.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  function observeElements() {
    document.querySelectorAll('.barq-reveal, .barq-reveal-scale').forEach((el) => {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
  }

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeElements);
  } else {
    observeElements();
  }

  // Re-observe when new sections are added (Shopify theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(observeElements, 100);
    });
  }

  // Smooth lazy image reveal
  document.addEventListener('load', function (e) {
    if (e.target.tagName === 'IMG' && e.target.loading === 'lazy') {
      e.target.classList.add('loaded');
    }
  }, true);
})();
